import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const AuthWrapper = ({ children }) => {
  const { userData } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (userData?.user_type === 1) {
      navigate('/CMS');
    }
  }, [userData, navigate]);

  return children;
};

export default AuthWrapper;
